var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "border-b border-slate-300" },
    [
      _c(
        "div",
        { staticClass: "px-5 py-2 flex items-center justify-between" },
        [
          _c("div", { staticClass: "flex items-center gap-2" }, [
            _c(
              "div",
              [
                _c("BlTextBody2", {
                  attrs: { text: _vm.period.start_time_string }
                }),
                _vm._v(" "),
                _c("BlTextBody2", { attrs: { text: "-" } }),
                _vm._v(" "),
                _c("BlTextBody2", {
                  attrs: { text: _vm.period.end_time_string }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.period.appointment.client && _vm.period.appointment.client.name
              ? _c(
                  "div",
                  {
                    staticClass: "truncate",
                    attrs: { title: _vm.period.appointment.client.name }
                  },
                  [
                    _c("BlTextSubtitle3", {
                      staticClass: "truncate",
                      attrs: { text: "" + _vm.period.appointment.client.name }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex items-center gap-2" },
            [
              _c("BlInputButton", {
                attrs: { type: "outlined", label: "Reschedule", dense: "" },
                on: {
                  clicked: function($event) {
                    _vm.rescheduleOpened = true
                  }
                }
              }),
              _vm._v(" "),
              _c("BlInputButton", {
                attrs: { type: "outlined", label: "Cancel", dense: "" },
                on: {
                  clicked: function($event) {
                    _vm.cancelOpened = true
                  }
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.rescheduleOpened && _vm.currentUser.role.includes("admin")
        ? _c("RescheduleAppointmentOverlay", {
            attrs: { appointmentId: _vm.period.appointment.id },
            on: {
              "close-modal": function($event) {
                _vm.rescheduleOpened = false
              },
              "after-commit": function($event) {
                return _vm.$emit("after-commit")
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.cancelOpened && _vm.currentUser.role.includes("admin")
        ? _c("CancelAppointmentModal", {
            attrs: { appointmentId: _vm.period.appointment.id },
            on: {
              "close-modal": function($event) {
                _vm.cancelOpened = false
              },
              "after-commit": function($event) {
                return _vm.$emit("after-commit")
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-071a92a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-071a92a2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointments/overlapped/ResolveAppointment.vue
// module id = null
// module chunks = 